import {Component, Injector} from '@angular/core';
import {PressVideoState, Store as PressVideoStore} from './state/store';
import {PressVideo} from './state/model';
import {PressVideoService as PressVideoService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {PressVideoQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class PressVideoDetailComponent extends EntityDetailComponent<PressVideo, PressVideoState, PressVideoStore> {

  constructor(
    public injector: Injector,
    service: PressVideoService,
    protected query: PressVideoQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
